__turbopack_context__.v({
  "content": "index-module-scss-module__NQY9AG__content",
  "hero": "index-module-scss-module__NQY9AG__hero",
  "heroText": "index-module-scss-module__NQY9AG__heroText",
  "heroTitle": "index-module-scss-module__NQY9AG__heroTitle",
  "inlineSection": "index-module-scss-module__NQY9AG__inlineSection",
  "learnMoreButton": "index-module-scss-module__NQY9AG__learnMoreButton",
  "mantine-Accordion-content": "index-module-scss-module__NQY9AG__mantine-Accordion-content",
});
